import {CSSProperties, FC} from 'react';


export interface IIconTransmissionMProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconTransmissionM: FC<IIconTransmissionMProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path fillRule="evenodd" d="M12.401 5.956h-1.513c-.719 0-.72 1.087 0 1.087H12.4c1.039 0 1.646-1.176 1.048-2.021C14.046 4.178 13.44 3 12.4 3h-1.513c-.719 0-.72 1.087 0 1.087H12.4c.258 0 .259.391 0 .391h-.922c-.718 0-.719 1.087 0 1.087h.922c.258 0 .259.391 0 .391ZM4.245 4.088h-.277c-.717 0-.721-1.088 0-1.088h.82c.3 0 .544.243.544.544v2.973c0 .717-1.087.72-1.087 0v-2.43Zm1.18 15.098c1.5-.275 1.3-2.507-.226-2.507H3.662c-.718 0-.719 1.087 0 1.087H5.2c.209 0 .236.313.03.35-2.45.45-2.476 2.606-1.567 2.606h2.253c.718 0 .719-1.087 0-1.087H4.382c.224-.31.496-.356.868-.419l.175-.03Zm14.808.336c1.193-.806.618-2.671-.816-2.671h-1.272c-.3 0-.544.243-.544.543v3.057c0 .72 1.088.717 1.088 0v-.68h.308l.932 1.042c.475.53 1.297-.182.81-.725l-.506-.566Zm-1.544-1.584h.728c.494 0 .494.747 0 .747h-.729v-.747Zm-5.679.44h.314c.72 0 .719 1.087 0 1.087h-.314v.814c0 .72-1.087.719-1.087 0v-.814h-1.25a.544.544 0 0 1-.544-.543v-1.599c0-.719 1.087-.718 1.087 0v1.055h.707v-1.055c0-.719 1.087-.718 1.087 0v1.055Zm6.477-12.422h-1.238c-.718 0-.72 1.087 0 1.087h1.238c1.7 0 1.7-2.565 0-2.565h-.627l.047-.39h1.323c.718 0 .72-1.088 0-1.088h-1.807a.544.544 0 0 0-.54.48l-.174 1.478a.544.544 0 0 0 .54.607h1.238c.264 0 .264.391 0 .391Zm.28 9.62c0 .719-1.087.718-1.087 0V12.54h-4.595a2.163 2.163 0 0 1-1.543 1.543v1.492c0 .72-1.087.718-1.087 0v-1.492a2.163 2.163 0 0 1-1.544-1.543H5.316v3.035c0 .719-1.087.718-1.087 0V8.419c0-.72 1.087-.719 1.087 0v3.034h4.595a2.163 2.163 0 0 1 1.544-1.543V8.418c0-.719 1.087-.718 1.087 0V9.91c.753.196 1.347.79 1.543 1.543h4.595V8.42c0-.72 1.087-.719 1.087 0v7.157Zm-7.769-2.51c.59 0 1.07-.48 1.07-1.069a1.07 1.07 0 0 0-2.138 0c0 .59.479 1.07 1.068 1.07Z" clipRule="evenodd" />
        </svg>
    );
};
